module.exports = __webpack_public_path__ + "img/temp_created_mind.19bf1af2.svg";